import { format, isSameMinute as isSameMinute$1, isSameDay as isSameDay$1, isBefore as isBefore$1, isWithinInterval, eachDayOfInterval, addYears, addMonths, addWeeks, addDays } from 'date-fns';
import Cookie from 'js-cookie';
import qs from 'qs';
import ispo from 'lodash/isPlainObject';
import React__default, { useEffect, useRef, useState, createElement } from 'react';
import deburr from 'lodash/deburr';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';

// TODO: refactor to use `formatDate`
var dateToDayAndNumberString = function (date) { return format(date, 'EEEE d'); };
var dateToDayNumberMonthYearString = function (date) {
    return format(date, 'EEEE d MMMM, yyyy');
};
var dateToLocalTime = function (date, timeFormat) {
    if (timeFormat === void 0) { timeFormat = '24h'; }
    return timeFormat === 'amPm' ? format(date, 'h:mma') : format(date, 'H:mm');
};
var datesToLocalTimeSpan = function (from, until, timeFormat) {
    if (timeFormat === void 0) { timeFormat = '24h'; }
    return dateToLocalTime(from, timeFormat) + " - " + dateToLocalTime(until, timeFormat);
};
/**
 * @deprecated Use dateToLocalTime
 */
var dateToShortTime = function (date) { return dateToLocalTime(date); };
var isSameMinute = function (date1, date2) { return isSameMinute$1(date1, date2); };
var isSameDay = function (date1, date2) { return isSameDay$1(date1, date2); };
var isBefore = function (date1, date2) { return isBefore$1(date1, date2); };
var isDateBefore = function (date1, date2) {
    return new Date(date1).setHours(0, 0, 0, 0) < new Date(date2).setHours(0, 0, 0, 0);
};
var isWithinTimeSpan = function (date, start, end) {
    return isWithinInterval(date, { start: start, end: end });
};
/**
 * Serialize a Date as a local ISO8601 datetime string. Like Date.prototype.toISOString,
 * but in the local timezone and without the timezone offset.
 */
var toLocalDateTime = function (date) { return format(date, "yyyy-MM-dd'T'HH:mm:ss"); };
/**
 * Serialize a Date as a local ISO8601 date string. Like Date.prototype.toISOString,
 * but in the local timezone and just the date, no time or timezone offset.
 */
var toLocalDate = function (date) { return format(date, 'yyyy-MM-dd'); };
var eachDay = function (start, end) { return eachDayOfInterval({ start: start, end: end }); };
var shiftDate = function (date, period, amount) {
    if (amount === void 0) { amount = 1; }
    switch (period) {
        case 'day':
            return addDays(date, amount);
        case 'week':
            return addWeeks(date, amount);
        case 'month':
            return addMonths(date, amount);
        case 'year':
            return addYears(date, amount);
    }
};
var getDateListFromDate = function (date, size) {
    if (size === void 0) { size = 7; }
    return eachDay(date, shiftDate(date, 'day', size - 1));
};

var dateUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dateToDayAndNumberString: dateToDayAndNumberString,
  dateToDayNumberMonthYearString: dateToDayNumberMonthYearString,
  dateToLocalTime: dateToLocalTime,
  datesToLocalTimeSpan: datesToLocalTimeSpan,
  dateToShortTime: dateToShortTime,
  isSameMinute: isSameMinute,
  isSameDay: isSameDay,
  isBefore: isBefore,
  isDateBefore: isDateBefore,
  isWithinTimeSpan: isWithinTimeSpan,
  toLocalDateTime: toLocalDateTime,
  toLocalDate: toLocalDate,
  eachDay: eachDay,
  shiftDate: shiftDate,
  getDateListFromDate: getDateListFromDate
});

var getEnvironmentValues = function (env, _a) {
    var prefix = _a.prefix;
    return Object.keys(env)
        .filter(function (e) { return e.startsWith(prefix) && env[e] !== 'false' && env[e]; })
        .map(function (e) { return e.substring(prefix.length); });
};
var parseEnvironmentString = function (str) {
    return str
        .split(';')
        .filter(function (kv) { return kv.includes('='); })
        .map(function (kv) { return kv.split(/=(.*)/); })
        .reduce(function (bi, kv) {
        bi[kv[0]] = kv[1];
        return bi;
    }, {});
};
var getFeatures = function (prefix) {
    if (prefix === void 0) { prefix = 'FEATURE_'; }
    return getEnvironmentValues(process.env, { prefix: prefix });
};
var getBuildInfo = function (name) {
    if (name === void 0) { name = 'BUILD_INFO'; }
    return parseEnvironmentString(process.env[name] || '');
};

var environmentUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFeatures: getFeatures,
  getBuildInfo: getBuildInfo
});

var isLocalizedRequest = function (request) {
    return 'locale' in request;
};
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["km"] = "km";
    DistanceUnit["meter"] = "meter";
    DistanceUnit["mile"] = "mile";
})(DistanceUnit || (DistanceUnit = {}));

/**
 * Utility functions to manage all the Locale related tasks
 */
var LOCALE_REGEX = /[a-z]{2}(_|-)[A-Z]{2}/g; // Regex to validate locale from a string input
var LOCALE_COOKIE_NAME = 'selected_locale'; // Cookie name to store the locale setting in a browser cookie
function getLocale(req, defaultLocale, isCmsPreview) {
    if (isCmsPreview === void 0) { isCmsPreview = false; }
    var locale = isLocalizedRequest(req)
        ? isCmsPreview
            ? getLocaleFromUrl(req.url)
            : getLocaleFromUrlOrReq(req)
        : defaultLocale;
    return locale || defaultLocale;
}
function getLocaleFromUrlOrReq(req) {
    return getLocaleFromUrl(req.url) || getLocaleFromRequest(req);
}
function getLocaleFromRequest(req) {
    return req && req.locale && req.locale.language + "-" + req.locale.region;
}
function getLocaleFromCookie() {
    return Cookie.get(LOCALE_COOKIE_NAME);
}
function getLocaleFromUrl(url) {
    var urlWithoutParams = url && url.split('?')[0];
    var locale = urlWithoutParams && urlWithoutParams.split('/').find(function (part) { return isValidLocale(part); });
    return locale && locale.replace('_', '-');
}
function setLocaleToCookie(locale) {
    var expiryDate = new Date(Date.now());
    expiryDate.setFullYear(expiryDate.getFullYear() + 2);
    Cookie.set(LOCALE_COOKIE_NAME, locale, { expires: expiryDate });
}
function isValidLocale(locale) {
    return !!locale.match(LOCALE_REGEX) && locale.length === 5;
}
function getLocaleSwitchPath(basePath) {
    var urlParts = window.location.href.split('?');
    return urlParts && urlParts.length > 1 ? basePath + "?" + urlParts[1] : basePath;
}

var localeUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOCALE_REGEX: LOCALE_REGEX,
  LOCALE_COOKIE_NAME: LOCALE_COOKIE_NAME,
  getLocale: getLocale,
  getLocaleFromUrlOrReq: getLocaleFromUrlOrReq,
  getLocaleFromRequest: getLocaleFromRequest,
  getLocaleFromCookie: getLocaleFromCookie,
  getLocaleFromUrl: getLocaleFromUrl,
  setLocaleToCookie: setLocaleToCookie,
  isValidLocale: isValidLocale,
  getLocaleSwitchPath: getLocaleSwitchPath
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var isArray = function (value) { return Array.isArray(value); };
var isBoolean = function (value) { return typeof value === 'boolean'; };
var isNil = function (value) { return value == null; };
var isNumber = function (value) {
    return typeof value === 'number' && Number.isFinite(value);
};
var isPlainObject = function (obj) { return obj && ispo(obj); };
var isString = function (value) { return typeof value === 'string'; };

var parse = function (urlPart, ignoreQueryPrefix) {
    if (ignoreQueryPrefix === void 0) { ignoreQueryPrefix = false; }
    return qs.parse(urlPart.substring(urlPart.indexOf('?') + 1), { ignoreQueryPrefix: ignoreQueryPrefix });
};
var stringify = function (params, noQuestionMark, keyDivision, valueDivision, encode) {
    if (noQuestionMark === void 0) { noQuestionMark = false; }
    if (keyDivision === void 0) { keyDivision = '&'; }
    if (valueDivision === void 0) { valueDivision = '='; }
    if (encode === void 0) { encode = true; }
    return valueDivision === '='
        ? "" + (noQuestionMark ? '' : '?') + qs.stringify(params, {
            delimiter: keyDivision,
            arrayFormat: 'comma',
            encode: encode,
        })
        : Object.entries(params).reduce(function (acc, _a, index) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return "" + acc + (!index ? (noQuestionMark ? '' : '?') : keyDivision) + key + valueDivision + value;
        }, '');
};
var toQueryParams = function (params, noQuestionMark) {
    if (noQuestionMark === void 0) { noQuestionMark = false; }
    return Object.entries(params).reduce(function (acc, _a, index) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return "" + acc + (!index ? (noQuestionMark ? '' : '?') : '&') + key + "=" + (isString(value) ? value : stringify(value, true, '|', ':'));
    }, '');
};

var query = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parse: parse,
  stringify: stringify,
  toQueryParams: toQueryParams
});

var guard = function (fieldName, value, defaultValue) {
    if (!value && isString(defaultValue)) {
        return defaultValue;
    }
    if (isString(value)) {
        return value;
    }
    throw new Error(fieldName + ": value " + value + " is not a string");
};

var stringGuard = /*#__PURE__*/Object.freeze({
  __proto__: null,
  guard: guard
});

function useDebouncedEffect(fn, delay, deps) {
    if (deps === void 0) { deps = []; }
    useEffect(function () {
        var id = setTimeout(fn, delay);
        return function () { return clearTimeout(id); };
    }, __spread([delay], deps));
}

var useEventListener = function (type, listener) {
    var refHandler = useRef(listener);
    /**
     * Make use of ref.current if the listener changes.
     * This ref updates the handler when it is changed without having to add it to the dependencies in the eventlistener effect
     * this in turn removes many potential re-runs of the effect which would result in many add/remove listeners to the dom.
     */
    useEffect(function () {
        refHandler.current = listener;
    }, [listener]);
    useEffect(function () {
        var isSupported = window && window.addEventListener;
        if (!isSupported) {
            console.warn('Event target does not have an addEventListener method');
            return;
        }
        var handler = function (event) { return refHandler.current(event); };
        window.addEventListener(type, handler);
        return function () {
            window.removeEventListener(type, handler);
        };
    }, [type]);
};

/**
 * withPlusSign
 *
 * Appends a plus sign to positive numbers of string type
 */
function withPlusSign(value) {
    var castValue = +value;
    return isNaN(castValue) || castValue <= 0 ? value : "+" + value;
}

var unspaceString = (function (value) { return value.replace(/\s+/g, ''); });

var slugify = function (string) {
    return deburr(string) // remove diacritics
        .toLowerCase() // make it all lowercase
        .trim() // remove whitespace before and after
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-'); // Replace multiple - with single -
};

var replaceWhitespace = (function (value, replace) { return value.replace(/\s+/g, replace); });

function createScriptTag(options) {
    var async = options.async, defer = options.defer, id = options.id, src = options.src, cb = options.cb, text = options.text;
    var script = document.createElement('script');
    if (async) {
        script.setAttribute('async', '');
    }
    if (defer) {
        script.setAttribute('defer', '');
    }
    if (id) {
        script.id = id;
    }
    if (src) {
        script.src = src;
    }
    if (cb) {
        script.onload = cb;
    }
    if (text) {
        script.text = text;
    }
    return script;
}
function injectTags(tags) {
    var head = document.head;
    if (head) {
        tags.forEach(function (tag) {
            head.appendChild(tag);
        });
    }
}

var isRealLocation = function (p) {
    return typeof p.lat === 'number' &&
        typeof p.lon === 'number' &&
        p.lat >= -90 &&
        p.lat <= 90 &&
        p.lon >= -180 &&
        p.lon <= 180;
};

var rad = function (degrees) { return (degrees * Math.PI) / 180; };
var deg = function (radians) { return (radians * 180) / Math.PI; };

var RADIUS = 6371000; // earth radius in meters
var sin = Math.sin, cos = Math.cos, atan2 = Math.atan2, sqrt = Math.sqrt;
/**
 * Calculate the geodesic distance in meters between two points on earth using
 * the haversine formula (rounded to the nearest meter). Can return Infinity if
 * either point has missing or invalid coordinates.
 */
function getDistance(start, end) {
    if (!isRealLocation(start) || !isRealLocation(end)) {
        return Infinity;
    }
    var dLat = rad(end.lat - start.lat);
    var dLon = rad(end.lon - start.lon);
    var a = sin(dLat / 2) * sin(dLat / 2) +
        sin(dLon / 2) * sin(dLon / 2) * cos(rad(start.lat)) * cos(rad(end.lat));
    var c = 2 * atan2(sqrt(a), sqrt(1 - a));
    return Math.round(RADIUS * c);
}

var sin$1 = Math.sin, cos$1 = Math.cos, atan2$1 = Math.atan2, sqrt$1 = Math.sqrt;
/**
 * Calculate the average coordinates of a list of points. Points with
 * invalid coordinates are ignored. Returns `null` if none of the points
 * have valid coordinates.
 */
var getCenter = function (points) {
    if (!points.length) {
        return null;
    }
    var x = 0;
    var y = 0;
    var z = 0;
    var n = 0;
    points.forEach(function (point) {
        if (isRealLocation(point)) {
            var lat = rad(point.lat);
            var lon = rad(point.lon);
            x += cos$1(lat) * cos$1(lon);
            y += cos$1(lat) * sin$1(lon);
            z += sin$1(lat);
            n += 1;
        }
    });
    if (n === 0) {
        return null;
    }
    x /= n;
    y /= n;
    z /= n;
    return {
        lat: deg(atan2$1(z, sqrt$1(Math.pow(x, 2) + Math.pow(y, 2)))),
        lon: deg(atan2$1(y, x)),
    };
};

var toKm = function (meters) { return meters / 1000; };
var toMiles = function (meters) { return meters / 1609.344; };
/**
 * Given a value of a type like `SomeType | WithDistance<SomeType>`, check
 * whether the value is of type `SomeType` or of type `WithDistance<SomeType>`.
 */
var hasDistance = function (value) { return 'distance' in value && typeof value.distance === 'number'; };
/**
 * Format a DistanceInMeters to a string representation in the given DistanceUnit.
 */
var formatDistance = function (distance, distanceUnit, options) {
    if (typeof distance !== 'number' || distance === Infinity) {
        return '';
    }
    switch (distanceUnit) {
        case DistanceUnit.km:
            return toKm(distance).toFixed(options ? options.precision : 1) + "km";
        case DistanceUnit.mile:
            return toMiles(distance).toFixed(options ? options.precision : 1) + "mi";
        case DistanceUnit.meter:
            return distance.toFixed(options ? options.precision : 0) + "m";
        default:
            console.warn("Unknown distance unit " + distanceUnit);
            return distance.toFixed(options ? options.precision : 0);
    }
};

/**
 * Find each `item`'s geodesic distance to the `reference` (in meters). Returns
 * an array of `[item, distance]` tuples, sorted by distance.
 */
var sortByDistance = function (reference, items) {
    return items
        .map(function (item) { return [item, getDistance(reference, item)]; })
        .sort(function (a, b) { return a[1] - b[1]; });
};

/**
 * Find the `limit` items that are nearest to the `reference` point on the
 * surface of earth. Returns an array of objects cloned from the original
 * items, with the `distance` in meters added.
 */
var findNearestCoordinates = function (reference, items, options) {
    if (options === void 0) { options = { limit: 1 }; }
    return sortByDistance(reference, items)
        .slice(0, options.limit)
        .map(function (_a) {
        var _b = __read(_a, 2), item = _b[0], distance = _b[1];
        return (__assign(__assign({}, item), { distance: distance }));
    });
};

function useLocalStorage(key, initialValue, shouldRemove) {
    if (shouldRemove === void 0) { shouldRemove = function (v) { return v === null; }; }
    var _a = __read(useState(function () {
        try {
            if (window.localStorage.hasOwnProperty(key)) {
                return JSON.parse(window.localStorage.getItem(key));
            }
        }
        catch (err) { }
        return initialValue;
    }), 2), value = _a[0], setValue = _a[1];
    useEffect(function () {
        try {
            shouldRemove(value)
                ? window.localStorage.removeItem(key)
                : window.localStorage.setItem(key, JSON.stringify(value));
        }
        catch (err) { }
    }, [key, value]);
    return [value, setValue];
}

function useSessionStorage(key, initialValue, shouldRemove) {
    if (shouldRemove === void 0) { shouldRemove = function (v) { return v === null; }; }
    var _a = __read(useState(function () {
        try {
            if (window.sessionStorage.hasOwnProperty(key)) {
                return JSON.parse(window.sessionStorage.getItem(key));
            }
        }
        catch (err) { }
        return initialValue;
    }), 2), value = _a[0], setValue = _a[1];
    useEffect(function () {
        try {
            shouldRemove(value)
                ? window.sessionStorage.removeItem(key)
                : window.sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (err) { }
    }, [key, value]);
    return [value, setValue];
}

var calculateHeaderHeight = function () {
    var _a, _b;
    return ((_a = document === null || document === void 0 ? void 0 : document.querySelector('.header')) === null || _a === void 0 ? void 0 : _a.clientHeight) || ((_b = 
    //if the regular header height is 0 we check the mobile header
    document === null || 
    //if the regular header height is 0 we check the mobile header
    document === void 0 ? void 0 : 
    //if the regular header height is 0 we check the mobile header
    document.querySelector('.header__header')) === null || _b === void 0 ? void 0 : _b.clientHeight) ||
        0;
};

var formatHour = function (hoursData) {
    var validHourRegex = /\d{3,4}/;
    if (!hoursData) {
        return '';
    }
    var hour;
    hour = hoursData.toString();
    hour = hour.length === 3 ? "0" + hour : hour;
    if (validHourRegex.test(hour)) {
        var hours = hour.length === 4 ? hour.slice(0, 2) : "0" + hour.slice(0, 1);
        var minutes = hour.length === 4 ? hour.slice(2) : hour.slice(1);
        return hours + ":" + minutes;
    }
    else {
        return 'unknown';
    }
};

var isDefined = function (v) { return typeof v !== 'undefined'; };
var isNumber$1 = function (v) { return !isNaN(v) && typeof v === 'number'; };
/**
 * Default formatters
 */
var decimalFormatter = function (v) {
    return isDefined(v) ? v.toFixed(2) : undefined;
};
var defaultFormatter = function (v) {
    if (!isDefined(v) || !isNumber$1(v)) {
        return undefined;
    }
    if (v === 0) {
        return decimalFormatter(v);
    }
    // Add a '+' sign for positive numbers. Negative numbers already have a '-' sign
    var sign = v > 0 ? '+' : '';
    return "" + sign + decimalFormatter(v);
};
/**
 * Specific formatters
 */
var convertToString = function (v) {
    return isDefined(v) && isNumber$1(v) ? v.toString() : undefined;
};
var specificFormatters = {
    pupillaryDistance: convertToString,
    axis: convertToString,
};
var getFormatter = function (prescriptionAttribute) { var _a; return (_a = specificFormatters[prescriptionAttribute]) !== null && _a !== void 0 ? _a : defaultFormatter; };
/**
 * Format prescription values
 */
var formatPrescriptionValue = function (prescriptionAttribute, value) {
    return getFormatter(prescriptionAttribute)(value);
};

var formatPrescriptionValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFormatter: getFormatter,
  formatPrescriptionValue: formatPrescriptionValue
});

var getNestedProperty = function (obj, path, defaultValue) {
    if (!obj || !path) {
        return defaultValue || undefined;
    }
    var pathArray = path.split('.');
    var result = pathArray.reduce(function (obj, prop) {
        return obj && obj[prop] ? obj[prop] : null;
    }, obj);
    return result || defaultValue || undefined;
};

var getLocalizedValue = function (attribute, locale) {
    if (locale === void 0) { locale = ''; }
    if (!isPlainObject(attribute)) {
        return '';
    }
    var language = locale.substr(0, 2);
    var attr = attribute;
    // CT Enum has a definition of key and label inside value
    if (attribute.hasOwnProperty('key') && attribute.hasOwnProperty('label')) {
        attr = attribute.label;
    }
    var result = attr[locale] || attr[language] || getNestedProperty(attr, 'en') || '';
    if (isPlainObject(result)) {
        return '';
    }
    return result;
};
var getLocalizedValues = function (attributes, localeLang) {
    if (localeLang === void 0) { localeLang = ''; }
    if (!Array.isArray(attributes)) {
        return [];
    }
    return attributes.map(function (attr) { return getLocalizedValue(attr, localeLang); });
};

var findAttribute = function (input, attrName) {
    return input && input.attributes ? input.attributes.find(function (attr) { return attr.name === attrName; }) : undefined;
};
var getAttrValue = function (input, attrName) {
    var attr = findAttribute(input, attrName);
    // CT Enum has a definition of key and label inside value
    if (isPlainObject(attr) &&
        attr.value &&
        attr.value.hasOwnProperty('key') &&
        attr.value.hasOwnProperty('label')) {
        return attr.value.label;
    }
    return attr && attr.value;
};
var getLocalizedAttrValue = function (input, attrName, locale) {
    var attr = getAttrValue(input, attrName);
    if (!isPlainObject(attr)) {
        return '';
    }
    return getLocalizedValue(attr, locale);
};
var getLocalizedAttrValues = function (input, attrName, locale) {
    var attr = getAttrValue(input, attrName);
    if (!Array.isArray(attr)) {
        return [];
    }
    return getLocalizedValues(attr, locale);
};

var PRESCRIPTION_SORTING_ARRAY = ['power', 'cylinder', 'axis', 'addition', 'pupillaryDistance'];
function sortPrescriptionParameters(paramNames) {
    var knownParams = paramNames.filter(function (p) { return PRESCRIPTION_SORTING_ARRAY.includes(p); });
    var unknownParams = paramNames.filter(function (p) { return !PRESCRIPTION_SORTING_ARRAY.includes(p); });
    var sortedParams = knownParams.sort(function (a, b) { return PRESCRIPTION_SORTING_ARRAY.indexOf(a) - PRESCRIPTION_SORTING_ARRAY.indexOf(b); });
    var sortedUnknownParams = unknownParams.sort();
    return __spread(sortedParams, sortedUnknownParams);
}

/**
 * Allows to bind a handler to the beforeunload event
 * @example
 *  const clearSessionStorage = (e) => sessionStorage.clear('item')
 *  useBeforeunload(clearSessionStorage)
 */
var useBeforeunload = function (handler) {
    React__default.useEffect(function () {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('beforeunload', handler);
        return function () { return window.removeEventListener('beforeunload', handler); };
    }, [handler]);
};

function withLazyLoading(Component, options) {
    var _a = options || {}, _b = _a.rootMargin, rootMargin = _b === void 0 ? '150px 0px' : _b, className = _a.className, _c = _a.classNameAfterLoad, classNameAfterLoad = _c === void 0 ? '' : _c, _d = _a.classNameBeforeLoad, classNameBeforeLoad = _d === void 0 ? '' : _d, dataT = _a["data-t"];
    var wrappedName = Component.displayName || Component.name || 'Component';
    var withLazyLoading = function (props) {
        var _a;
        var _b = __read(useInView({
            rootMargin: rootMargin,
            triggerOnce: true,
        }), 2), inViewRef = _b[0], inView = _b[1];
        var containerClassName = classnames('lazy-loading', className, [
            (_a = {},
                _a["" + classNameBeforeLoad] = !inView,
                _a["" + classNameAfterLoad] = inView,
                _a),
        ]);
        return (createElement("div", { className: containerClassName, ref: inViewRef, "data-t": dataT }, inView ? createElement(Component, __assign({}, props)) : null));
    };
    withLazyLoading.displayName = "WithLazyLoading(" + wrappedName + ")";
    return withLazyLoading;
}

export { dateUtils as DateUtils, DistanceUnit, environmentUtils as EnvironmentUtils, localeUtils as LocaleUtils, formatPrescriptionValue$1 as PrescriptionValueUtils, query as QueryString, stringGuard as StringGuard, calculateHeaderHeight, createScriptTag, findNearestCoordinates, formatDistance, formatHour, getAttrValue, getCenter, getDistance, getLocalizedAttrValue, getLocalizedAttrValues, getLocalizedValue, getLocalizedValues, getNestedProperty, hasDistance, injectTags, isArray, isBoolean, isNil, isNumber, isPlainObject, isString, replaceWhitespace, slugify, sortPrescriptionParameters, toKm, toMiles, unspaceString, useBeforeunload, useDebouncedEffect, useEventListener, useLocalStorage, useSessionStorage, withLazyLoading, withPlusSign };
//# sourceMappingURL=index.es.js.map
